import { capitalize, startCase } from 'lodash-es';

export function sentenceCase(value: string): string {
	return capitalize(startCase(value));
}
